import { render, staticRenderFns } from "./RedirectsTable.vue?vue&type=template&id=114ee483&"
import script from "./RedirectsTable.vue?vue&type=script&lang=js&"
export * from "./RedirectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('114ee483')) {
      api.createRecord('114ee483', component.options)
    } else {
      api.reload('114ee483', component.options)
    }
    module.hot.accept("./RedirectsTable.vue?vue&type=template&id=114ee483&", function () {
      api.rerender('114ee483', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/Redirects/RedirectsTable.vue"
export default component.exports